import { render } from "./SecondaryInsurance.vue?vue&type=template&id=17bca0a8"
import script from "./SecondaryInsurance.vue?vue&type=script&lang=js"
export * from "./SecondaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/billingInfo/forms/SecondaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17bca0a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17bca0a8', __exports__)) {
    console.log('reload')
    api.reload('17bca0a8', __exports__)
  }
  
  module.hot.accept("./SecondaryInsurance.vue?vue&type=template&id=17bca0a8", () => {
    console.log('re-render')
    api.rerender('17bca0a8', render)
  })

}


export default __exports__